<div class="chart-container">
  <div
    #chartContainer
    class="chart-content"
  ></div>
</div>
